import { fontSize, spacer } from "@paprika/stylers/lib/helpers";
import styled from "styled-components";
import tokens from "@paprika/tokens";
import { getAvatarColors } from "./helpers";
var roundStyles = {
  small: "\n    border-radius: 50%;\n    height: ".concat(spacer(2.5), ";\n    width: ").concat(spacer(2.5), ";\n  "),
  medium: "\n    border-radius: 50%;\n    height: ".concat(spacer(3), ";\n    width: ").concat(spacer(3), ";\n  "),
  large: "\n    border-radius: 50%;\n    height: ".concat(spacer(4), ";\n    width: ").concat(spacer(4), ";\n  ")
};
var roundStringStyles = {
  small: fontSize(-4),
  medium: "font-size: 12px;",
  large: fontSize(-1)
};
var roundIconStyles = {
  small: fontSize(-2),
  medium: fontSize(-1),
  large: fontSize(2)
};
var squareStyles = {
  medium: "\n    border-radius: ".concat(tokens.button.borderRadius, ";\n    height: ").concat(spacer(4), ";\n    width: ").concat(spacer(4), ";\n  "),
  large: "\n    border-radius: ".concat(tokens.card.borderRadius, ";\n    height: ").concat(spacer(5), ";\n    width: ").concat(spacer(5), ";\n  ")
};
var squareStringStyles = {
  medium: fontSize(0),
  large: fontSize(2)
};
var squareIconStyles = {
  medium: fontSize(2),
  large: fontSize(4)
};

function getSizeCss(size, isRound, isChildString) {
  var sizeValue;

  if (isRound) {
    sizeValue = roundStyles[size].concat(isChildString ? roundStringStyles[size] : roundIconStyles[size]);
  } else {
    sizeValue = squareStyles[size].concat(isChildString ? squareStringStyles[size] : squareIconStyles[size]);
  }

  return sizeValue;
}

export var Avatar = styled.div.withConfig({
  displayName: "Avatarstyles__Avatar",
  componentId: "sc-1wpkrh6-0"
})(["align-items:center;display:inline-flex;font-weight:bold;justify-content:center;overflow:hidden;&,*{box-sizing:border-box;}", ""], function (_ref) {
  var $backgroundColor = _ref.$backgroundColor,
      $color = _ref.$color,
      isChildString = _ref.isChildString,
      isRound = _ref.isRound,
      size = _ref.size,
      children = _ref.children;
  var color = isChildString ? getAvatarColors(children) : {
    backgroundColor: tokens.color.blackLighten60,
    fontColor: tokens.color.blackLighten20
  };
  var backgroundColor = $backgroundColor !== null && $backgroundColor !== void 0 ? $backgroundColor : color.backgroundColor;
  var fontColor = $color !== null && $color !== void 0 ? $color : color.fontColor;
  var sizeValue = getSizeCss(size, isRound, isChildString);
  return "\n      background-color: ".concat(backgroundColor, ";\n      color: ").concat(fontColor, ";\n      ").concat(sizeValue, ";\n    ");
});
//# sourceMappingURL=Avatar.styles.js.map